import GameScreen, { GameScreenClone } from './scenes/GameScreen';
import IntroScreen from './scenes/IntroScreen';
import SelectLevelScreen from './scenes/SelectLevelScreen';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [IntroScreen, SelectLevelScreen, GameScreen, GameScreenClone],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: IntroScreen.KEY,
  CURRENT_LEVEL: 1,
  MUSIC_ON: true,
  INSTRUCTIONS_SHOWN: false,
  LEVELS_CLEARED: [false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false],
  storageKey: 'BlobbleLevels'
};
